import * as React from 'react';
import { createView, view } from '@sail/engine';
import { focusSafely, getFocusableTreeWalker } from '@sail/react-aria';
import { visuallyHidden } from '../../utilStyles/visuallyHidden';
/**
 * Strips out deprecated props from the Popover props object and returns
 * the rest.
 */ export const replaceDeprecatedProps = (props)=>{
    const { shouldFlip, shouldUpdatePosition, shouldRespectScrollBoundary, shouldCloseOnBlur, ...rest } = props;
    if (shouldCloseOnBlur !== undefined) {
        rest.dismissible = shouldCloseOnBlur;
    }
    if (shouldFlip !== undefined) {
        rest.flip = shouldFlip;
    }
    return rest;
};
export const FocusGuard = createView((props)=>{
    return /*#__PURE__*/ React.createElement(view.span, {
        hidden: true,
        tabIndex: 0,
        uses: [
            visuallyHidden
        ],
        ...props
    });
});
export const moveFocus = (ref, dir)=>(event)=>{
        const manager = ref.current;
        // first try moving focus within the popover
        const node = dir === 'next' ? manager === null || manager === void 0 ? void 0 : manager.focusFirst() : manager === null || manager === void 0 ? void 0 : manager.focusLast();
        // if the manager didn't find a focusable element within scope,
        // focus the next/previous element outside the popover.
        if (!node) {
            const root = event.currentTarget.getRootNode();
            const walker = getFocusableTreeWalker(root, {
                tabbable: true,
                from: event.currentTarget
            });
            const el = dir === 'next' ? walker.nextNode() : walker.previousNode();
            if (el) {
                focusSafely(el);
            }
        }
    };

//# sourceMappingURL=utils.js.map